import { useLocation } from 'react-router';
import { useScript } from '#Root/ThirdPartyScriptLoader/useScript';
import { useEffect } from 'react';

function useIntercomScript(intercomId: string) {
  useIntercom(intercomId);
  useUpdateIntercomOnRouteChange();
}

function useIntercom(intercomId: string) {
  const location = useLocation();
  const hideLauncher = routesWithoutIntercomLauncher.includes(
    location.pathname
  );

  const body = `
    var APP_ID = '${intercomId}';
    window.intercomSettings = {
      hide_default_launcher: ${hideLauncher},
    };

    (function(){var w=window;var ic=w.Intercom;if(typeof ic==="function"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text/javascript';s.async=true;s.src='https://widget.intercom.io/widget/' + APP_ID;var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(document.readyState==='complete'){l();}else if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
    window.Intercom("boot", {
      api_base: "https://api-iam.intercom.io",
      app_id: APP_ID,
    });
  `;
  useScript({ body });
}

const routesWithoutIntercomLauncher = [
  '/sign-up',
  '/sign-up-bundles',
  '/create-account',
];

function useUpdateIntercomOnRouteChange() {
  const location = useLocation();

  useEffect(() => {
    window.Intercom?.('update');
  }, [location]);
}

export { useIntercomScript, routesWithoutIntercomLauncher };
